module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.detailLan.datailText) + "  (" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "round": "",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.detailLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "downLoadTran": _vm.downLoadTran,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "multiLanguage": _vm.detailLan,
      "name": _vm.name,
      "thData": _vm.thData,
      "trData": _vm.trData
    }
  }, [_c('div', {
    staticClass: "monthly-detail",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "monthly-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.detailLan.proxyAccount) + " " + _vm._s(_vm.queryObj.IB_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "monthly-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.detailLan.commissionType) + " " + _vm._s(_vm.queryObj.type))])]), _vm._v(" "), (_vm.isLower) ? _c('div', {
    staticClass: "monthly-detail"
  }, [_c('el-switch', {
    attrs: {
      "active-text": _vm.detailLan.spread,
      "inactive-text": _vm.detailLan.fold,
      "active-color": "#3F51B5"
    },
    on: {
      "change": _vm.actionChange
    },
    model: {
      value: (_vm.action),
      callback: function($$v) {
        _vm.action = $$v
      },
      expression: "action"
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c2b95d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBResult/monthCommDetailResult.vue
// module id = 1105
// module chunks = 1